import React from 'react'

const Footer = () => {
  return (
    <div>
      <div
        className="row footer-text fixed-bottom py-3 text-center m-0"
        style={{
          borderTop: '1px solid gray',
          color: '#b3b1b1ff',
          backgroundColor: '#1a1a1a',
        }}
      >
        <span>
          © 2025 Shree Warana Vidyalaya, Warananagar — All Rights Reserved.
        </span>
      </div>
    </div>
  )
}

export default Footer
